import React, { useRef, useEffect } from "react";
import {  useAnimation } from "framer-motion";

const SkinCarePlan = () => {
  const ref = useRef(null);

  const doneControls = useAnimation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      doneControls
        .start({
          opacity: 1,
          scale: 1.2,
          zIndex: 20,
          transition: { duration: 0.5, ease: "easeOut" },
        })
        .then(() => {
          doneControls.start({
            x: 0,
            y: 0,
            scale: 1,
            zIndex: 0,
            transition: { duration: 0.8, ease: "easeInOut" },
          });
        });
    }, 1800);

    return () => clearTimeout(timeout);
  }, [doneControls]);

  return (
    <div ref={ref} className="flex flex-col items-center w-full px-4 pb-5">
      {/* Заголовок */}
      <div className="flex items-center justify-center w-full">
        <h1
          className="text-2xl sm:text-5xl text-center font-medium 
               bg-gradient-to-r from-[#FC5EB2] via-[#444CE7] to-[#FC5EB2] 
               bg-clip-text text-transparent 
               bg-[length:200%_200%] animate-gradient-x"
        >
          Unique personalized<br /> skincare plan
        </h1>
      </div>

      {/* Обертка телефонов */}
      <div className="relative flex justify-center items-center w-full max-w-[900px] sm:h-[750px] xss:h-[450px]  rounded-b-3xl bg-gradient-to-b from-[#FFFFFF] to-[#FFE0F1]">
        {/* Левый телефон */}
              <img
              loading="lazy"
                className="absolute xss:bottom-[120px] xss:left-[10%] xs:bottom-[140px] xs:left-[20%] sm:bottom-[180px] sm:left-[20%] xss:w-[150px] sm:w-[250px] "
                src="/iPhLeft.webp"
                alt="IphLeft"
              />

        {/* Правый телефон */}
          <img
          loading="lazy"
            className="absolute xss:bottom-[100px] xss:left-[45%] sm:bottom-[160px] sm:right-[25%] xss:w-[150px] sm:w-[250px] "
            src="/iPhRight.webp"
            alt="IphRight"
          />


        {/* Центральный телефон */}
        <img
        loading="lazy"
          className="absolute sm:bottom-[250px] sm:right-[40%] xs:bottom-[170px] xs:right-[35%] xss:bottom-[180px]  w-[120px] sm:w-[160px] md:w-[200px]"
          src="/iPhCenter.webp"
          alt="IphCenter"
        />


        {/* DoneLand с анимацией */}
        <img
        loading="lazy"
          className="absolute sm:bottom-[430px] sm:right-[40%] xss:bottom-[280px] xs:bottom-[270px] xss:left-[50%]  w-[80px] sm:w-[100px] animate-pulse"
          src="/doneLand.svg"
          alt="Done"
        />

        {/* Текст */}
        <h1 className="absolute bottom-[40px] text-sm sm:text-lg md:text-xl text-center italic font-normal text-gray-800 w-full px-4">
          Database of <span className="text-pink-400">45000+</span> products
          <br />
          selected specifically for you
        </h1>
      </div>
    </div>
  );
};

export default SkinCarePlan;
